import { Suspense } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { common } from '@ocean/ui'
import homeRoutes from 'modules/Home/routing/routes'
import RequirementCompletionDetailsRouting, {
  routes as requirementCompletionDetailsRoutes,
} from 'modules/requirements/RequirementCompletionDetails/routing'
import RequirementsRouting, { requirementsRoutes } from 'modules/requirements/Requirements/routing'
import routes from './routes'

export { routes }

const { RouteChangeProgress } = common

const Routing = () => {
  return (
    <Suspense fallback={<RouteChangeProgress />}>
      <Switch>
        <Route
          path={requirementCompletionDetailsRoutes.root}
          component={RequirementCompletionDetailsRouting}
        />
        <Route path={requirementsRoutes.root} component={RequirementsRouting} />
        <Redirect path='*' to={homeRoutes.root} />
      </Switch>
    </Suspense>
  )
}

export default Routing
